import React from 'react'

export default function Footer() {
    return (
        <div className="App-footer">
            Copyright 2013-{new Date().getFullYear()} © Rúbia Santos. All rights reserved.
        </div>
    )
}